/*
	Centralize UI app component to extend off of
*/
app.addFeature(
	'ui',
	function(){
		'use strict';

		var self = this;

		/*
			Name: init
			Use: API.init()
			Args: none
			Description: Initializes the component
		*/
		self.init = function(){

		};

		return self
	}
);
